import React, { useState, useCallback, useMemo } from 'react'
import { useHistory } from 'react-router-dom'

import { useCreateItem } from '../hooks'

import Button, { BUTTON_STYLES } from '../../common/components/Button'

import Form, { FORM_MODES } from './Form'

const Create = ({ fields, routeName, apiUrl }) => {
  const history = useHistory()
  const create = useCreateItem(apiUrl)

  const defaultFormState = useMemo(() => {
    let state = {}
    fields.forEach((field) => {
      state[field.name] = field.defaultValue
    })
    return state
  }, [fields])
  const [formState, setFormState] = useState(defaultFormState)

  const onCreate = useCallback(() => {
    create(formState)
    history.push(`/admin/${routeName}`)
  }, [history, routeName, formState, create])

  return (
    <div>
      <h2>Create</h2>
      <Form
        item={formState}
        onChange={setFormState}
        fields={fields}
        mode={FORM_MODES.CREATE}
      />
      <Button onClick={onCreate} text="Create" style={BUTTON_STYLES.PRIMARY} />
      <Button
        onClick={() => history.push(`/admin/${routeName}`)}
        text="Back To List"
      />
    </div>
  )
}

export default Create
